jQuery(document).ready(function($){
    $('#schedule-consultation').on('click', function(e){
        e.preventDefault();

        var baseURL = "/pages/custom-consultation";
        var currentPath = window.location.pathname;
        var slug = currentPath.split('/')[2];
        var destinationURL = baseURL + "?prod_url=" + encodeURIComponent(currentPath);

        window.open(destinationURL, '_blank');
    });
});